import { render, staticRenderFns } from "./TransferToUser.vue?vue&type=template&id=1859e3f4&scoped=true"
import script from "./TransferToUser.vue?vue&type=script&lang=js"
export * from "./TransferToUser.vue?vue&type=script&lang=js"
import style0 from "./TransferToUser.vue?vue&type=style&index=0&id=1859e3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1859e3f4",
  null
  
)

export default component.exports